'use client';

import { useEffect } from 'react';
import { Module } from '@/components/utilities/content-modules/module-list/module-list';
import ModuleList, {
  ModuleListProps,
} from '@/components/utilities/content-modules/module-list/module-list';
import {
  trackPageLoadEvent,
  trackViewEvent,
} from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';
import styles from './predefined-search.module.scss';

export interface PredefinedSearchProps extends ModuleListProps {
  /** An array of the modules to show */
  modules: Module[];
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const PredefinedSearch = ({
  modules,
  personalizationData,
  trackingData,
}: PredefinedSearchProps) => {
  useEffect(() => {
    trackPageLoadEvent({ content_group: 'predefined_search' });

    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.component}>
      <ModuleList modules={modules} />
    </div>
  );
};

PredefinedSearch.displayName = 'PredefinedSearch';

export default PredefinedSearch;
